var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1006(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M300.081,570.335c-82.962,19.748 -202.729,56.129 -201.391,220.596c0.717,87.988 52.32,135.823 103.987,161.504c49.888,24.797 99.626,28.278 99.626,28.278c0.443,0.031 0.887,0.047 1.331,0.048l612.167,0.218c0.664,-0 1.329,-0.035 1.99,-0.106c-0,0 230.36,-24.671 233.726,-251.946c2.82,-190.418 -155.509,-239.063 -222.889,-256.573c-7.205,-1.872 -14.582,-3.902 -18.675,-5.046c-28.001,-50.498 -52.757,-109.585 -111.148,-150.082c-40.936,-28.392 -98.339,-48.104 -185.272,-48.603c-121.995,-0.7 -197.015,63.26 -243.51,134.267c-43.908,67.056 -61.711,140.374 -69.942,167.445Zm4.288,372.922c-5.357,-0.475 -45.105,-4.572 -85.001,-24.402c-41.112,-20.435 -82.609,-58.216 -83.179,-128.23c-1.177,-144.666 111.216,-169.514 181.568,-185.929c3.263,-0.761 7.342,-2.486 10.962,-6.961c1.371,-1.694 3.404,-5.023 5.232,-10.227c1.968,-5.6 4.619,-15.334 8.303,-27.982c21.289,-73.072 79.743,-254.502 271.064,-253.403c76.877,0.441 127.915,16.81 164.116,41.917c55.255,38.322 76.121,95.902 102.88,143.086c1.477,2.606 4.29,6.204 9.859,8.938c4.331,2.127 14.674,4.856 29.023,8.585c58.219,15.129 197.262,55.194 194.825,219.723c-2.765,186.701 -184.902,213.294 -199.297,215.105c-0.011,0.001 -610.315,-0.216 -610.315,-0.216l-0.04,-0.004Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1006);
export default __webpack_public_path__ + "static/media/1006.c8f4f6a61e935990f028f85aa2dc5ce6.svg";
export { ForwardRef as ReactComponent };